import { createFileRoute } from '@tanstack/react-router'

import { TelaDeCargos } from '@/components/gestor/cargos/TelaDeCargos'

/*
 * `/gestor/cargos`: a lista de cargos e a criação de um novo. A guarda e a
 * recusa por cargo moram na casca (`/gestor`), então esta tela só monta para
 * quem tem a área.
 */
export const Route = createFileRoute('/gestor/cargos')({ component: TelaDeCargos })
